import { TASK_EVENT_TYPE } from '../constants/task-event-type';
import TaskListItemType from '../constants/task-list-item-type';
var ICON_STATIC_PATH;
(function (ICON_STATIC_PATH) {
    ICON_STATIC_PATH["QUESTIONNAIRE"] = "/static/assets/icons/DLS_DoctorTreatmentPlan_48.svg";
    ICON_STATIC_PATH["PROFILE_UPDATE"] = "/static/assets/icons/DLS_PersonProfile_48.svg";
    ICON_STATIC_PATH["CONSENT_FORM"] = "/static/assets/icons/DLS_ImageInfoEdit_48.svg";
    ICON_STATIC_PATH["INSTITUTIONAL_MATERIAL"] = "/static/assets/icons/DLS_Articles.svg";
    ICON_STATIC_PATH["UPLOAD_FILE"] = "/static/assets/icons/DLS_CloudUpload_48.svg";
    ICON_STATIC_PATH["ASK_THE_PHYSICIAN"] = "/static/assets/icons/DLS_HelpQuestions_48.svg";
    ICON_STATIC_PATH["GUIDANCE_TO_THE_PATIENT"] = "/static/assets/icons/DLS_PatientDocument_24.svg";
})(ICON_STATIC_PATH || (ICON_STATIC_PATH = {}));
export class TaskListCardUtils {
    static getIconPath(taskType) {
        switch (taskType) {
            case TaskListItemType.CONSENT_FORM: return ICON_STATIC_PATH.CONSENT_FORM;
            case TaskListItemType.INSTITUTIONAL_MATERIAL: return ICON_STATIC_PATH.INSTITUTIONAL_MATERIAL;
            case TaskListItemType.PROFILE_UPDATE: return ICON_STATIC_PATH.PROFILE_UPDATE;
            case TaskListItemType.QUESTIONNAIRE: return ICON_STATIC_PATH.QUESTIONNAIRE;
            case TaskListItemType.UPLOAD_FILE: return ICON_STATIC_PATH.UPLOAD_FILE;
            case TaskListItemType.ASK_THE_PHYSICIAN: return ICON_STATIC_PATH.ASK_THE_PHYSICIAN;
            case TaskListItemType.GUIDANCE_TO_THE_PATIENT: return ICON_STATIC_PATH.GUIDANCE_TO_THE_PATIENT;
            default: return '';
        }
    }
    static getTaskExpression(taskType) {
        switch (taskType) {
            case TaskListItemType.CONSENT_FORM: return 'patient.consent-form';
            case TaskListItemType.INSTITUTIONAL_MATERIAL: return 'patient.institutional-material';
            case TaskListItemType.PROFILE_UPDATE: return 'patient.profile-update';
            case TaskListItemType.QUESTIONNAIRE: return 'patient.questionnaire';
            case TaskListItemType.UPLOAD_FILE: return 'patient.upload-file';
            case TaskListItemType.ASK_THE_PHYSICIAN: return 'patient.ask-the-physician';
            case TaskListItemType.GUIDANCE_TO_THE_PATIENT: return 'patient.guidance-to-the-patient';
            case TaskListItemType.SATISFACTION_SURVEY: return 'patient.satisfaction-survey';
            default: return '';
        }
    }
    static getExpressionForTaskTag(eventType) {
        if (TaskListCardUtils.isPreparationType(eventType)) {
            return 'patient.preparation';
        }
        if (TaskListCardUtils.isPostProcedureType(eventType)) {
            return 'patient.post-procedure';
        }
        return '';
    }
    static isPreparationType(eventType) {
        const { POST_EXAM_SCHEDULE, POST_CONSULTATION_SCHEDULE, POST_SURGERY_SCHEDULE, GOING_TO_PROMPT_SERVICE, } = TASK_EVENT_TYPE;
        const preparationTypes = [
            POST_EXAM_SCHEDULE,
            POST_CONSULTATION_SCHEDULE,
            POST_SURGERY_SCHEDULE,
            GOING_TO_PROMPT_SERVICE
        ];
        return preparationTypes.some(item => item === eventType);
    }
    static isPostProcedureType(eventType) {
        const { POST_CONSULTATION_SCHEDULE_EXEC, POST_EXAM_SCHEDULE_EXEC, POST_SURGERY_SCHEDULE_EXEC, POST_PATIENT_DISCHARGE } = TASK_EVENT_TYPE;
        const postProcedureTypes = [
            POST_CONSULTATION_SCHEDULE_EXEC,
            POST_EXAM_SCHEDULE_EXEC,
            POST_SURGERY_SCHEDULE_EXEC,
            POST_PATIENT_DISCHARGE
        ];
        return postProcedureTypes.some(item => item === eventType);
    }
}
//# sourceMappingURL=task-list-card-utils.js.map